import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Home } from 'lucide-react';

// Fetches the authenticated house image as a blob and renders it. Falls back to
// a placeholder when the house has no image or the fetch fails. `imageUrl` is the
// house.image_url value (e.g. "/api/houses/{id}/photo"); we derive the /houses
// path so it goes through the axios api client (which adds auth + baseURL).
export default function HouseImage({ houseId, imageUrl, className = '', refreshKey }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let alive = true;
    if (!imageUrl || !houseId) { setSrc(null); return undefined; }
    setFailed(false);
    (async () => {
      try {
        const res = await api.get(`/houses/${houseId}/photo`, { responseType: 'blob' });
        if (!alive) return;
        objectUrl = window.URL.createObjectURL(new Blob([res.data]));
        setSrc(objectUrl);
      } catch {
        if (alive) setFailed(true);
      }
    })();
    return () => { alive = false; if (objectUrl) window.URL.revokeObjectURL(objectUrl); };
  }, [houseId, imageUrl, refreshKey]);

  if (src && !failed) {
    return <img src={src} alt="House" className={className} data-testid="house-image" />;
  }
  return (
    <div className={`flex items-center justify-center bg-muted ${className}`} data-testid="house-image-placeholder">
      <Home className="h-8 w-8 text-muted-foreground" />
    </div>
  );
}
